import React from "react";
import HeroSec from "../heroSec";
import Feature from "../feature";
import Works from "../howItWorks";
import Stores from "../stores";
import MobileSection from "../mobileSection";
import Reviews from "../reviews";
import Download from "../download";
import { useMediaQuery } from "@mui/material";
import Description from "../Description/Description";
import InfiniteHorizontalScroll from "../howItWorks/Animtion1";
import Faq from "../faq/Faq";

const Home = () => {
  const isMobile = useMediaQuery("(max-width:640px)");

  const mobileBg = {
    backgroundImage: isMobile ? "url('/img/webpImg/mobileBg.webp')" : "none",
  };
  return (
    <div className="flex flex-col gap-[20px] md:gap-[84px] mt-10 md:mt-20">
      <div className="px-4 sm:px-8 lg:px-28 flex flex-col gap-[20px] md:gap-[84px]  ">
        <HeroSec />
        <Feature />
      </div>

      <Works />
      <div style={mobileBg} className="flex flex-col gap-[30px]">
        <Stores />
        <MobileSection />
      </div>
      <Reviews />
      <InfiniteHorizontalScroll />

      <Faq />
      <Download />

      <Description />
    </div>
  );
};

export default Home;
